/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {registerAppMessageAction} from '../api'

export const useMutationRegisterAppMessageAction = createReactQueryMutationHook('registerAppMessageAction', registerAppMessageAction)
